module.exports = __webpack_public_path__ + "images/jumpstart-footer-bg-mobile.png";